import { message } from "antd";
import { t } from "i18next";

export default {
  error: (error: any) => {
    let msg;

    if (typeof error === "string") {
      msg = error;
    } else if (typeof error?.content === "string") {
      msg = error.content;
    } else if (error instanceof Error || error?.message) {
      msg = error.message;
    } else {
      msg = t("server error");
    }

    let content = t(msg);
    message.error(content, typeof error?.duration === "number" ? error.duration : 3);
  },
  warning: (msg: string) => {
    let content = t(msg);
    message.info(content);
  },
  info: (msg: string) => {
    let content = t(msg);
    message.info(content);
  },
  success: (msg: string) => {
    let content = t(msg);
    message.success(content);
  },
};
